import { convertCreditsFromServerToClient } from "../../common/datastructures/Credits";
import { reverseArr } from "../../common/functions/Functions_General";
import { GameData } from "./gamestate/gameData";
// import { SymbolPayTable } from "./datastructures/payTableSymbols";

export class PayTableBuilder {
  private parent: PIXI.Container;
  private paytables: Array<PaySymbol>;
  private lines: number;
  private row: number;
  private activeGameData: GameData;

  constructor(parent: PIXI.Container, activeGameData: GameData) {
    this.parent = new PIXI.Container();
    this.paytables = [];
    this.lines = 0;
    this.row = 0;
    this.activeGameData = activeGameData;

    for (var i = 9; i >= 0; i--) {
      this.paytables[i] = new PaySymbol(i, this.parent, this.activeGameData);
      let posX = this.paytables[i].getWidth() * this.row;
      let posY = this.paytables[i].getWidth() * this.lines;
      this.paytables[i].setPosition([posX, posY]);

      this.row++;
      if (this.row > 3) {
        this.row = 0;
        this.lines++;
      }
    }
    parent.addChild(this.parent);
    if (activeGameData.isMobile) {
      this.parent.scale.set(0.65);

      this.parent.y = -90;
    } else {
      this.parent.scale.set(0.75);
      this.parent.y = -45;
    }
    this.parent.x = parent.width / 2 - this.parent.width / 2;
  }

  public updateAllPaytable() {
    // console.log(this)
    // console.log(this)
    for (var i = 0; i < this.paytables.length; i++) {
      this.paytables[i].updateDisplay();
    }
  }
  public setPosition(pos: Array<number>) {
    this.parent.position.set(pos[0], pos[1]);
    // this.updateAllPaytable()
  }

  public setPositionY = (newValue: number): void => {
    this.parent.y = newValue;
  };
  public getPosition = (): Array<number> => {
    return [this.parent.x, this.parent.y];
  };

  public getParent = (): PIXI.Container => {
    return this.parent;
  };


  

  public setOrientationLanscape=(isLandScape:boolean):void=>
  {
    this.row=0;
    this.lines=0;
    if(isLandScape)
    { 
    
      //landScape stuffs
      for (var i = 9; i >= 0; i--) {
        let posX = this.paytables[i].getWidth() * this.row;
        let posY = this.paytables[i].getWidth() * this.lines; 
        this.paytables[i].setPosition([posX, posY]);  
        this.paytables[i].getParent().scale.set(1);
        this.row++;
        if (this.row > 3) {
          this.row = 0;
          this.lines++;
        }
      }
    }
    else
    {
      //portrait mode
      for (var i = 9; i >= 0; i--) {
        this.paytables[i].getParent().scale.set(1.8);
        let posX = this.paytables[i].getWidth() * this.row-150;
        let posY = this.paytables[i].getWidth() * this.lines; 
        this.paytables[i].setPosition([posX, posY]);  
      
        this.row++;
        if (this.row > 2) {
          this.row = 0;
          this.lines++;
        }
      }
    }
  }
}

class PaySymbol {
  private parent: PIXI.Container;
  private bg: PIXI.Sprite;

  private multipliers: Array<string>;
  private winValue: Array<number>;
  private comboLength: number;
  private extraSpinStyle: PIXI.TextStyle;

  private icon: PIXI.Sprite;
  private multiplierText: Array<PIXI.Text>;
  private winValueText: Array<PIXI.Text>;
  private activeGameData: GameData;

  private fireSpinText: PIXI.Text;

  private symbolIndex: number;
  // private BonuspinNumber
  private descreasingOrder: boolean = true;

  constructor(
    diceIndex: number,
    parent: PIXI.Container,
    activeGameData: GameData
  ) {
    this.symbolIndex = diceIndex;
    this.symbolIndex;
    this.activeGameData = activeGameData;
    this.parent = new PIXI.Container();
    this.multipliers = ["x5", "x4", "x3", "x2"];
    this.winValue = [0, 0, 0, 0];
    this.comboLength = this.activeGameData.gamePayTableValues.getComLength(
      this.symbolIndex,
      true
    ).length;

    let pT = this.activeGameData.gamePayTableValues;

    //set Multiplier

    this.winValue = pT.getMultipler(diceIndex, false);
    // if(diceIndex==7)
    // {
    //   console.log( pT.getBonus(diceIndex, false))
    //   // this.winValue = pT.getBonus(diceIndex, false);
    // }
    let mt = pT.getComLength(diceIndex, false);

    if (this.descreasingOrder) {
      mt = reverseArr(mt);
    }

    // console.log(this.winValue, mt);
    for (let i = 0; i < mt.length; i++) {
      this.multipliers[i] = "x" + mt[i];
    }

    // console.log(this.winValue[0])

    this.extraSpinStyle = new PIXI.TextStyle({
      fontFamily: this.activeGameData.gameTextStyle.gameFont,
      fontSize: 40,
      fill: "#ffffff",
      fontWeight: "bold",
      lineHeight: 60,
      align: "center",

      dropShadow: true,
      dropShadowColor: "#000000",
      dropShadowBlur: 10,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,
    });

    this.bg = new PIXI.Sprite(PIXI.Texture.fromImage("dicePaytable.png"));
    this.icon = new PIXI.Sprite(
      PIXI.Texture.fromImage(
        this.activeGameData.tileImgName[diceIndex] + "_00010.png"
      )
    );

    this.multiplierText = [];
    this.winValueText = [];

    // console.log(this.activeGameData.tileImgName[diceIndex]+'00010.png');

    this.parent.addChild(this.bg);
    this.bg.addChild(this.icon);

    // console.log(this.comboLength);
    for (var i = 0; i < this.comboLength; i++) {
      this.multiplierText[i] = new PIXI.Text(
        this.multipliers[i],
        this.extraSpinStyle
      );

      this.multiplierText[i].y =
        this.multiplierText[i].height * i + this.multiplierText[i].height + 50;
      this.multiplierText[i].x = 60;
      this.bg.addChild(this.multiplierText[i]);
      //   console.log( this.multipliers[i],this.multiplierText[i].text,diceIndex);
      //   this.winValueText[i]=new PIXI.Text(convertCreditsFromServerToClient(this.activeGameData.betSelected.value*this.winValue[i]).toFixed(2),this.extraSpinStyle);
      let betSelected = this.activeGameData.betSelected.value;
      betSelected;
      let winValue = convertCreditsFromServerToClient(this.winValue[i]).toFixed(
        2
      );

      this.winValueText[i] = new PIXI.Text(winValue, this.extraSpinStyle);
      this.winValueText[i].scale.set(1);
      // this.winValueText[i].tint=0xff0000;
      this.winValueText[i].y = this.multiplierText[i].y;
      this.winValueText[i].x = this.bg.width - this.winValueText[i].width - 60;

      this.bg.addChild(this.winValueText[i]);
    }

    if (diceIndex === 8) {
      let spinsValuex3 = this.activeGameData.loginResponse.gameSettings.payTable
        .bonusGameCombinationPays[24].bonusSpins;
      let spinsValuex4 = this.activeGameData.loginResponse.gameSettings.payTable
        .bonusGameCombinationPays[25].bonusSpins;
      let spinsValuex5 = this.activeGameData.loginResponse.gameSettings.payTable
        .bonusGameCombinationPays[26].bonusSpins;
      let bonusRoundsText =
        spinsValuex3 + "/" + spinsValuex4 + "/" + spinsValuex5;
      // console.log(spinsValuex3,spinsValuex4,spinsValuex5)
      this.fireSpinText = new PIXI.Text(
        "\n BONUS " +
          activeGameData.gameTextGeneral.spin +
          "\n" +
          bonusRoundsText,
        this.extraSpinStyle
      );

      this.bg.addChild(this.fireSpinText);
      this.fireSpinText.scale.set(0.8);
      this.fireSpinText.y = 235; //this.multiplierText[this.comboLength-1].y+this.fireSpinText.height*2;
      this.fireSpinText.x = this.bg.width / 2 - this.fireSpinText.width / 2; //- this.fireSpinText.width/2
    }

    if (diceIndex === 9) {
      this.fireSpinText = new PIXI.Text("\n WILD", this.extraSpinStyle);
      // this.icon.texture=(PIXI.Texture.fromImage(this.activeGameData.tileImgName[8]+'_00010.png'));
      this.bg.addChild(this.fireSpinText);
      this.fireSpinText.scale.set(0.8);
      this.fireSpinText.y = 250; //this.multiplierText[this.comboLength-1].y+this.fireSpinText.height*2;
      this.fireSpinText.x = this.bg.width / 2 - this.fireSpinText.width / 2; //- this.fireSpinText.width/2
    }

    // console.log(this.activeGameData.betSelected.value);

    parent.addChild(this.parent);

    this.setup();
  }

  private setup = (): void => {
    this.parent.y = 100;
    this.icon.anchor.set(0.5);
    this.icon.scale.set(1.2);
    this.icon.x = this.bg.width / 2;
    this.icon.y = this.bg.height / 2; //-180;
    this.icon.alpha = 0.4;
  };

  public updateDisplay = (): void => {

      let updateValue = [];
      for (var i = 0; i < this.comboLength; i++) {
        updateValue[i] = convertCreditsFromServerToClient(
          (this.activeGameData.betSelected.value * this.winValue[i]) /
            this.activeGameData.loginResponse.gameSettings.payTable
              .baseGameWinLineCount
        ).toFixed(2);

        if (this.symbolIndex == 8) {
          let multiplierScatter: number = this.activeGameData.loginResponse
            .gameSettings.payTable.bonusGameCombinationPays[24+i].multiplier;
          updateValue[i] =convertCreditsFromServerToClient(
            this.activeGameData.betSelected.value * multiplierScatter
          ).toFixed(2);

     
        }
      }

      //invert  if reveresed order
      if (this.descreasingOrder) {
        updateValue = reverseArr(updateValue);
      }

      // assign value to text

      for (var i = 0; i < this.comboLength; i++) {
        this.winValueText[i].text = updateValue[i];
        this.winValueText[i].x =
          this.bg.width - this.winValueText[i].width - 60;
          
      this.winValueText[i].x = this.bg.width - this.winValueText[i].width - 60;
      }
      // //old
      // this.winValueText[i].text = convertCreditsFromServerToClient(
      //   (this.activeGameData.betSelected.value * this.winValue[i]) /
      //     this.activeGameData.loginResponse.gameSettings.payTable
      //       .baseGameWinLineCount
      // ).toFixed(2);
      // if (this.symbolIndex == 8) {    
      //   let multiplierScatter: number = this.activeGameData.loginResponse
      //     .gameSettings.payTable.bonusGameCombinationPays[24 + i].multiplier;
      //   this.winValueText[i].text = convertCreditsFromServerToClient(
      //     this.activeGameData.betSelected.value * multiplierScatter
      //   ).toFixed(2);
      // }

    
  };

  public setPosition(pos: Array<number>) {
    this.bg.position.set(pos[0], pos[1]);
  }

  public getHeight() {
    return this.bg.height;
  }

  public getWidth() {
    return this.bg.width;
  }

  public getParent = (): PIXI.Container => {
    return this.parent;
  };
}
